module.exports = __webpack_public_path__ + "img/tech_1.de893fbd.png";